import {useFormContext} from "react-hook-form";
import {FiClock} from "react-icons/fi";

import {RadioGroup} from "@/components/form/RadioGroup.tsx";
import {ON_CALL_STATE_TITLE} from "@/lib/constants/contacts.ts";
import {ScheduleState} from "@/lib/types/checks.ts";

export const OnCallHoursRadioGroup = () => {
  const {setValue, watch} = useFormContext();
  const scheduleStates = [ScheduleState.ACTIVE, ScheduleState.SCHEDULED];
  const name = "schedule_state";
  return (
    <RadioGroup
      name={name}
      options={scheduleStates.map((s) => ({value: s, label: ON_CALL_STATE_TITLE[s]}))}
      labelIcons={{
        [ScheduleState.SCHEDULED]: FiClock,
      }}
      value={watch(name)}
      onChange={(v) => setValue(name, v, {shouldDirty: true})}
      required
      hasRequiredLabel={false}
    />
  );
};
